import fetchAPI from '../../fetchAPI';

export interface CancelJobResponse {
  jobId: string;
  status: 'cancelled';
}

export const callCancelJob = async (jobId: string): Promise<iResponse<CancelJobResponse>> => {
  const response = await fetchAPI<CancelJobResponse>({
    method: 'POST',
    route: `jobs/${jobId}/cancel`,
    data: {}
  });
  return response;
};

export default callCancelJob;
